/* eslint-disable @typescript-eslint/ban-types */
import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
export interface AuthReducer {
  isLoading: boolean
  error: string | null
}

const initialState: AuthReducer = {
  isLoading: false,
  error: null
}

export interface SignInPayload {
  email: string
  password: string
}

export type SignInAction = PayloadAction<SignInPayload>

export const SIGN_IN = createAction<SignInPayload>('SIGN_IN')
export const SIGN_IN_SUCCESS = createAction('SIGN_IN_SUCCESS')
export const SIGN_IN_FAIL = createAction('SIGN_IN_FAIL')

export const SIGN_OUT = createAction('auth_reducer/sign_out')
export const SIGN_OUT_SUCCESS = createAction('auth_reducer/sign_out_success')
export const SIGN_OUT_FAIL = createAction('auth_reducer/sign_out_fail')

export const authReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SIGN_IN, (state, action) => {
      return { ...state, isLoading: true, error: null }
    })
    .addCase(SIGN_IN_SUCCESS, (state) => {
      return { ...state, isLoading: false, error: null }
    })
    .addCase(SIGN_IN_FAIL, (state) => {
      return { ...state, isLoading: false, error: 'Ungültige E-Mail oder Passwort' }
    })
})
export default authReducer
